
class GoogleDriveApi {

    constructor(token) {
        this.token = token

        this.apiUrl = 'https://www.googleapis.com'
        this.downloadUrl = 'https://docs.google.com/document/u/0/export?format=html&id='

        this.uploadPath = '/upload/drive/v2/files?convert=true';
        this.deletePath = '/drive/v2/files/';

        this.upload = this.upload.bind(this)
        this.delete = this.delete.bind(this)

    }

    setToken(token) {
        this.token = token
    }

    async list() {
        try {
            const response = await fetch(this.apiUrl + this.deletePath, { 
                method: 'GET', 
                headers: new Headers({
                    'Authorization' : `Bearer ${this.token}`,
                })
            }).then(r => r.json())
         
            return response

        } catch (error) {
            throw error
        }
    }

    async upload(file) {
        console.log(this.token)
        try {
            const response = await fetch(this.apiUrl + this.uploadPath, { 
                method: 'POST', 
                headers: new Headers({
                    'Authorization' : `Bearer ${this.token}`,
                    'Content-Type': file.type
                }),
                body: new Blob([file]) 
            }).then(r => r.json())

            return response

        } catch (error) {
            throw error
        }

    }

    async delete(id) {
        try {
            const response = await fetch(this.apiUrl + this.deletePath + id, { 
                method: 'DELETE', 
                headers: new Headers({
                    'Authorization' : `Bearer ${this.token}`
                })
            })

            return response

        } catch (error) {
            throw error
        }
    }

    async download(id) {
        try {
            const page = await fetch(this.downloadUrl + id, { 
                method: 'GET', 
                headers: new Headers({
                    'Authorization' : `Bearer ${this.token}`,
                    //'Content-Type': file.type
                })
            }).then(r => r.text())

            return page

        } catch (error) {
            throw error
        }
    }

}

export default GoogleDriveApi